import { render, staticRenderFns } from "./RecommendationsSlide.vue?vue&type=template&id=bc4bd4b0&scoped=true&"
import script from "./RecommendationsSlide.vue?vue&type=script&lang=js&"
export * from "./RecommendationsSlide.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsSlide.vue?vue&type=style&index=0&id=bc4bd4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4bd4b0",
  null
  
)

export default component.exports